<template>
  <v-menu :offset-y="true" bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="menuClick" v-for="(item, i) in items" :key="i">
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
 
export default {
  data: () => ({
    items: [{ title: "Sair" }],
  }),
  methods: {
    menuClick(event) {
      this.$store.dispatch('logout');
    },
  },
};
</script>